// extracted by mini-css-extract-plugin
module.exports = {"ButtonOutline":"ButtonOutline_ButtonOutline__3Qvul","accent":"ButtonOutline_accent__8xf8I","inverse":"ButtonOutline_inverse__2gBF3","disabled":"ButtonOutline_disabled__2UHDH"};